// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getStorage } from "firebase/storage";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyAhmNP1lJUNwhp6kPpzQuyrznetgfco0Uo",
  authDomain: "cognisigner.firebaseapp.com",
  projectId: "cognisigner",
  storageBucket: "cognisigner.appspot.com",
  messagingSenderId: "562489052880",
  appId: "1:562489052880:web:bd346aa3154869bfb9d8d5",
  measurementId: "G-Y6FRM1ETRP",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const analytics = getAnalytics(app);
const storage = getStorage(app);
const db = getFirestore(app);

export { app, analytics, storage, db, auth };
